// extracted by mini-css-extract-plugin
export default {"counterWrapperCount":"styles_counterWrapperCount__mDmwa","counterWrapperWarn":"styles_counterWrapperWarn__tpwZW"};